// pages/Payment/styles.js
import styled from 'styled-components';

export const PaymentPageWrapper = styled.div`
    min-height: calc(100vh - 72px);
    background: ${props => props.theme.colors.background.alt};
    padding: ${props => props.theme.spacing['4xl']} ${props => props.theme.spacing.xl};
    margin-top: 72px; // Account for navbar height
`;